import React, { useEffect, useRef } from "react";

const Login = () => {
  const redirectInitiated = useRef(false);

  useEffect(() => {
    const redirectToSSO = () => {
      // Prevent multiple redirects
      if (redirectInitiated.current) {
        console.log("Redirect already initiated, skipping");
        return;
      }

      // Check if we have an oauthState already
      const existingOAuthState = sessionStorage.getItem("oauthState");
      if (existingOAuthState) {
        console.log("OAuth flow already in progress, skipping redirect to SSO");
        return;
      }

      // Mark redirect as initiated
      redirectInitiated.current = true;

      // Add a timestamp to prevent stale redirects
      const redirectTimestamp = Date.now();
      const lastRedirect = sessionStorage.getItem("lastSSORedirect");

      // Prevent redirect if we just did one in the last 5 seconds
      if (lastRedirect && redirectTimestamp - parseInt(lastRedirect) < 5000) {
        console.log("Recent redirect detected, preventing loop");
        return;
      }

      sessionStorage.setItem("lastSSORedirect", redirectTimestamp.toString());

      // Generate state
      const state =
        Date.now().toString(36) + Math.random().toString(36).substring(2);

      // Handle bypassmfacaptcha
      const urlParams = new URLSearchParams(window.location.search);
      const bypassMfa = urlParams.get("bypassmfacaptcha");
      const storedBypassMfa = sessionStorage.getItem("bypassmfacaptcha");

      if (bypassMfa === "true" || storedBypassMfa === "true") {
        sessionStorage.setItem("bypassmfacaptcha", "true");
        console.log("MFA bypass flag detected and stored");
      }

      // Store current path
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath !== "/login" && !currentPath.startsWith("/login?")) {
        sessionStorage.setItem("originalPath", currentPath);
        console.log("Stored originalPath:", currentPath);
      }

      // Store OAuth state
      sessionStorage.setItem("oauthState", state);
      console.log("Generated OAuth state:", state);

      const redirectUri = encodeURIComponent(
        process.env.REACT_APP_REDIRECT_URI
      );
      let ssoRedirect = `https://sso.thomsonreuters.com/as/authorization.oauth2?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=code&scope=openid%20profile%20email&redirect_uri=${redirectUri}&state=${state}`;

      if (bypassMfa === "true" || storedBypassMfa === "true") {
        ssoRedirect += "&bypassmfacaptcha=true";
        console.log("Adding bypassmfacaptcha to SSO redirect URL");
      }

      console.log("Redirecting to SSO...");

      // CHANGED: Use window.location.replace() instead of href for better behavior
      window.location.replace(ssoRedirect);
    };

    // Add a small delay to ensure component is fully mounted
    const timer = setTimeout(redirectToSSO, 150);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <div>Redirecting to login...</div>
      <div style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
        Please wait while we redirect you to Thomson Reuters SSO.
      </div>
    </div>
  );
};
export default Login;
